export const styles = {
  containerDescription: (h) => {
    return {
      cursor: "pointer",
      width: "100%",
      height: `${h}px`,
      margin: 0,
      zIndex: 5
    };
  },
  description: (h) => {
    return {
      fontSize: "0.9rem",
      height: `${h}px`,
      display: "flex",
      alignItems: "center",
      paddingLeft: "15px"
    };
  }
};
